
// SVG Icon: zoom-out
export default { id: "terriajs-zoom-out" };
export const id = "terriajs-zoom-out";
export const name = "zoom-out";
